'use server'

import { apiRequest, ApiResponse } from '../request'

export interface PaymentTerminal {
    id: number
    name: string
    serialNumber: string
    provider: string
    credentials: Record<string, string>
    sandboxMode: boolean
    webhookSecret?: string | null
    companyId: number
    active: boolean
    metadata?: any
    createdAt: string
    updatedAt: string
}

export interface CreateTerminalData {
    name: string
    serialNumber: string
    provider: string
    credentials: Record<string, string>
    sandboxMode?: boolean
    webhookSecret?: string
    active?: boolean
    metadata?: any
}

export interface UpdateTerminalData extends Partial<CreateTerminalData> {}

const BASE = 'financial/terminals'

export async function getTerminals(): Promise<ApiResponse<PaymentTerminal[]>> {
    return apiRequest<PaymentTerminal[]>(BASE, {})
}

export async function getTerminal(id: number): Promise<ApiResponse<PaymentTerminal>> {
    return apiRequest<PaymentTerminal>(`${BASE}/${id}`, {})
}

export async function getTerminalsByProvider(provider: string): Promise<ApiResponse<PaymentTerminal[]>> {
    return apiRequest<PaymentTerminal[]>(`${BASE}/by-provider/${provider}`, {})
}

export async function createTerminal(data: CreateTerminalData): Promise<ApiResponse<PaymentTerminal>> {
    return apiRequest<PaymentTerminal>(BASE, { data }, 'post')
}

export async function updateTerminal(id: number, data: UpdateTerminalData): Promise<ApiResponse<PaymentTerminal>> {
    return apiRequest<PaymentTerminal>(`${BASE}/${id}`, { data }, 'patch')
}

export async function deleteTerminal(id: number): Promise<ApiResponse<void>> {
    return apiRequest<void>(`${BASE}/${id}`, {}, 'delete')
}
